import Parse from "parse";
import { getClassName } from "./ParseConfiguration";
import {
    NotificationReminderTime,
    NotificationReminderTimeModel
} from "../Models/NotificationReminderTime.ts";
import { handleError } from "./ErrorHandler.ts";


const CLASS_NAME: any = getClassName("MembershipExpirationReminderTime")


export async function getMembershipExpirationReminderTime(): Promise<NotificationReminderTimeModel | null> {
    try {
        const query = new Parse.Query(CLASS_NAME)
        const result = await query.first()
        if (!result) return null
        return NotificationReminderTime.convertFromParseObject(result)

    } catch (error) {
        handleError(error)
        throw error
    }
}

export async function updateMembershipExpirationReminderTime(hours: number): Promise<any> {
    try {
        const query = new Parse.Query(CLASS_NAME)
        let object = await query.first()

        if (!object) {
            const ParseObject = Parse.Object.extend(CLASS_NAME)
            object = new ParseObject()
        }

        object.set("hours", hours)
        await object.save()

    } catch (error) {
        handleError(error)
        throw error
    }
}
